const translations = {
    mainNav: {
        language: "Idioma",
        shoppingBasket: "Carrito",
        login: "Iniciar sesión",
        logout: "Cerrar sesión",
        register: "Registrarse",
        user: "Usuario",
        bookings: "Reservas",
        transfers: "Traslados",
        profile: "Perfil",
    },
    footer: {
        legalNotice: "Política legal",
        privacyPolicy: "Política de privacidad",
        contractTerms: "Política de contratación",
        cookiesPolicy: "Política de Cookies",
        complaintChannel: "Canal de Denuncia"
    },
    bookingForm: {
        event: "Evento",
        selectEventToBook: "Selecciona el evento para reservar",
        checkIn: "Desde",
        checkOut: "Hasta",
        guest: "Huésped",
        guests: "Huéspedes",
        addDate: "Agregar fecha",
        addGuest: "Agregar",
        numberOfRooms: "Habitaciones",
        adults: "Adultos",
        children: "Niños",
        roomNumber: "Habitación {{number}}",
    },
    bookingMeForm: {
        event: "Evento",
        city: "Ciudad",
        hotel: "Hotel",
        confirmationNumber: "Número",
        bookingStatus: "Estado",
        paymentStatus: "Estado del pago",
        searchByEvent: "Buscar por evento",
        year: "Año",
        searchByBookingStatus: "Buscar por estado de la reserva",
        searchByPaymentStatus: "Buscar por estado del pago",
        searchByConfirmationNumber: "Buscar por número de confirmación",
        searchByCity: "Buscar por ciudad",
        searchByHotel: "Buscar por hotel",
        searchByYear: "Buscar por año",
        name: "Estado de la reserva",
        confirmed: "Confirmada",
        pending: "Pendiente",
        canceled: "Cancelada",
        paid: "Pagada",
        notPaid: "No pagada",
        refunded: "Reembolsada",
    },
    cityEventMainCard: {
        hotels: "Hoteles",
        transferService: "Servicio de traslado",
        from: "Del",
        to: "hasta",
    },
    hotelMapCard: {
        minNightsRequired: "Este hotel requiere un mínimo de {{noches}} noches",
        discountCode: "{{code}}",
        forNight: "desde <PriceFormatter>{{price}}</PriceFormatter> por noche",
        externalRedirectTitle: "Estás a punto de salir de nuestra web",
        externalRedirectMessage: "Te redirigiremos a la página web de Booking.com para que puedas continuar con tu reserva. ¿Quieres continuar?",
        cancel: "Cancelar",
        ok: "Ir a Booking.com",
    },
    hotelDetail: {
        amenities: "Servicios",
        amenitiesDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        viewMoreAmenities: "ver más servicios",
        informationAndExtras: "Información y extras",
        informationAndExtrasDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        location: "Localización",
        cancellationPolicy: "Política de cancelación",
        modifyDates: "Modificar fechas",
        addRoom: "Añadir habitación",
        from: "Desde:",
        to: "Hasta:",
        capacity: "Capacidad:",
        total: "Total",
        roomAdded: "Habitación añadida",
        roomNotAvailable: "Habitación no disponible",
        roomNotAvailableAt: "No hay disponibilidad para estas noches: {{dates}}",
        roomAvailableWithOverbooking: "Habitación con dias pendientes de confirmación",
        roomAvailableWithOverbookingAt: `Reserva con días pendientes de confirmación. Nuestro equipo comprobará la disponibilidad de estas noches y se comunicará contigo lo antes posible: {{dates}}`,
        roomAvailableWithOverbookingOnRequest: "BAJO DEMANDA",
        roomAvailableWithOverbookingConfirm: `Por favor haga clic en confirmar para continuar`,
        hotelNotAvailable: "No puede agregar habitaciones de hoteles diferentes",
        addRoomErrorTitle: "Ocurrió un error",
        addRoomError: "Ocurrió un error y no se pudo añadir la habitación al carrito",
        goToCheckout: "Ir a la cesta",
        details: "Detalles",
        quantity: "Cantidad",
    },
    common: {
        actions: {
            add: "Añadir",
            accept: "Aceptar",
            cancel: "Cancelar",
            edit: "Editar",
            delete: "Eliminar",
            submit: "Enviar",
            save: "Guardar",
            upload_file: "Subir archivo",
            search: "Buscar",
            show_more_filters: "Mostrar más filtros",
            hide_more_filters: "Ocultar más filtros",
            clear: "Limpiar",
            back: "Volver",
            goHome: "Ir a inicio",
            copy: "Copiar",
            confirm: "Confirmar",
            select: "Seleccionar",
            selected: "Seleccionado",
            send: "Enviar",
            loading: "Cargando",
            close: "Cerrar",
            loginOrRegisterMsg: "¡<LoginLink>Inicia sesión</LoginLink> o <RegisterLink>regístrate</RegisterLink> para guardar tu reserva y acceder a ella en cualquier momento!",
            next: "Siguiente",
            previous: "Anterior",
            sending: "Enviando",
            complete: "Completar",
            unSelect: "Borrar Selección",
        },
        labels: {
            required_field: "Campo obligatorio",
            filters: "Filtros",
            none: "Ninguno",
            all: "Todos",
            creation_date: "Fecha de creación",
            error: "Error",
            administration: "Administración",
            actions: "Acciones",
            selected_items: "{{count}} elemento/s seleccionado/s",
            per_page: "Por página",
            sort_by: "Ordenar por",
            total: "Total",
            language: "Idioma",
            iAcceptThe: "He leído y acepto la <AcceptButton>{{terms}}</AcceptButton>",
        },
        feedback: {
            saved_data: "Datos guardados con éxito",
            no_data: "No hay datos",
            form_not_valid: "Hay errores en el formulario",
            field_required: "El campo es obligatorio",
            field_min: "El valor del campo no puede ser inferior a {{min}}",
            field_max: "El valor del campo no puede ser superior a {{max}}",
            field_min_length:
                "La longitud del campo no puede ser menor a {{length}}",
            field_max_length:
                "La longitud del campo no puede ser mayor a  {{length}}",
            field_valid_email: "{{value}} no es un correo electrónico válido",
            field_valid_iban: "{{value}} no es un IBAN correcto",
            unexpected_error: "Ha ocurrido un error inesperado",
            field_required_terms: "Debe leer y aceptar la {{terms}}",
             time_cannot_be_in_past: "La hora no puede ser menor a la hora actual",
        },
        enum: {
            transportType: {
                plane: "Avión",
                train: "Tren",
                bus: "Autobús",
                other: "Otro",
            },
            transferDirection: {
                oneWay: "Llegada",
                comeBack: "Salida",
                both: "Llegada y Salida",
            },
            transferVehicle: {
                sedan: "Sedan",
                van: "Van",
                businessSedan: "Business Sedan",
                businessVan: "Business Van",
            },
            transferStatus: {
                pending: "Pendiente",
                transferCreated: "Traslado Creado",
                updated: "Actualizado",
                cancelled: "Cancelado",
                confirmed: "Confirmado",
                requestInfo: "Solicitud de Información",
                formSent: "Formulario Enviado",
            },
        },
    },
    auth: {
        actions: {
            sign_in: "Iniciar sesión",
            logout: "Cerrar sesión",
            reset_password: "Restablecer contraseña",
        },
        fields: {
            email: "Correo electrónico",
            password: "Contraseña",
            new_password: "Nueva contraseña",
            confirm_new_password: "Confirmar nueva contraseña",
        },
        labels: {
            forgot_password: "¿Has olvidado la contraseña?",
            forgot_password_subheading:
                "Introduce tu correo electrónico para restablecer tu contraseña",
        },
        feedback: {
            unauthorized: "La sesión no es válida",
            passwords_does_not_match: "Las contraseñas no coinciden",
        },
    },

    error404: {
        labels: {
            heading:
                "Lo sentimos, parece que no podemos encontrar la página que estás buscando.",
            subheading:
                "Es posible que haya un error ortográfico en la URL introducida o que la página que estás buscando ya no exista.",
        },
    },

    home: {
        title: "Inicio",
    },
    cart: {
        title: "Carrito",
    },
    checkout: {
        title: "Detalles de reserva",
        continueShopping: "Continuar comprando",
        noItemsInTheCart: "No hay nada en el carrito",
        total: "Total",
        total_without_taxes: "Total sin IVA",
        total_taxes: "IVA",
        total_basket: "Total Reserva",
        total_pending: "Total Pendiente",
        discount: "Descuento",
        total_to_pay: "Total a pagar",
        total_payed: "Total pagado",
        confirm_booking: "Confirmar reserva",
        clear_basket: "Vaciar carrito",
        total_nights: "Noches",
        nights: "noches",
        night_of: "Noche del",
        from: "Desde",
        to: "Hasta",
        delete: "Eliminar",
        book_price_detail: "Detalle de precios",
        errorWithPaymentItWillBeRefund: "Ha ocurrido un error en el proceso de pago. Si se ha realizado el cobro, se devolverá de manera íntegra a la mayor brevedad posible. Por favor, contacte con un administrador si el error persiste.",
        status: {
            name: "Estado",
            pending: "Pendiente",
            confirmed: "Confirmada",
            canceled: "Cancelada",
        },
        paymentStatus: {
            unpaid: "No pagada",
            payment_requested: "Pago solicitado",
            payment_scheduled: "Pago programado",
            paid: "Pagada",
            refunded: "Reembolsada",
        },
    },
    booking: {
        title: "Confirmar reserva",
        noBookings: "No tienes reservas todavía.",
        personalInformation: "Información personal",
        paymentInformation: "Información de pago",
        invoiceInformation: "Información de facturación",
        name: "Nombre",
        surname: "Apellidos",
        email: "Correo electrónico",
        telephone: "Teléfono",
        invalidTelephone: "El teléfono no es válido",
        roomsWithOverbookingDisclaimer: "Al finalizar la reserva nos pondremos en contacto contigo lo antes posible ya que esta reserva quedará pendiente de confirmación para los siguiente días",
        roomsToBePaidAtTheHotelDisclaimer: "Esta reserva contiene habitaciones para pagar en el hotel, los detalles de la tarjeta de crédito son necesarios para garantizar la habitación con el hotel.",
        paymentRequiredDisclaimer: "Alguien del equipo de Love Events se pondrá en contacto contigo en breve para realizar el pago.",
        creditCardInformation: "Información de la tarjeta de crédito",
        creditCardHolder: "Titular de la tarjeta de crédito",
        creditCardNumber: "Número de la tarjeta de crédito",
        invalidCreditCardNumber: "Por favor introduce un número de tarjeta de crédito válido",
        expiration: "Caducidad",
        invalidCreditCardExpiration: "La fecha de caducidad de la tarjeta de crédito debe ser posterior a la de la reserva",
        invalidCreditCardExpirationActualDate: "La fecha de caducidad de la tarjeta de crédito debe ser posterior a la fecha actual",
        roomDetails: "Detalles de las habitaciones",
        room: "Habitación",
        guests: "Huéspedes",
        guestN: "Huésped {{number}}",
        child: "Niño",
        checkInTime: "Hora de entrada",
        iDontKnow: "No lo sé",
        comments: "Comentarios",
        acceptTerms: "He leído y acepto los ",
        termsAndConditions: "Términos y Condiciones",
        submit: "Finalizar la reserva",
        formContainsErrors: "Hay campos inválidos en el formulario. Por favor revisa el formulario y vuelve a pulsar \"Finalizar reserva\".",
        errorWhenMakingTheBookingHeading: "Error al hacer la reserva",
        errorWhenMakingTheBookingBody: "Ha ocurrido un error al hacer la reserva. Por favor vuelve a intentarlo. Si el problema persiste contacta con nosotros.",
        prebookingHasExpiredError: "Su pre-reserva ha expirado después de {{prebookingExpiresIn}} minutos de inactividad. Por favor, inicia el proceso de reserva nuevamente.",
        bookingDetails: "Detalles de la reserva",
        bookingDetailsSubtitle: "Información personal de la reserva",
        invoiceNameAndSurname: "Nombre completo",
        nationality: "Nacionalidad",
        documentType: "Tipo Documento",
        passport: "Pasaporte",
        nie: "NIE",
        dni: "DNI",
        nif: "NIF",
        vat: "VAT",
        other: "Otro",
        invalidDocumentTypeFormat: "{{documentType}} con formato inválido",
        invalidDocumentTypeLetter: "Letra del {{documentType}} no válida",
        invalidNIEFormat: "NIE con formato inválido",
        invalidNIELetter: "Letra del NIE no válida",
        invoicePassportCif: "Número",
        invoiceAddress: "Dirección fiscal",
        payment: "Pago",
        scheduledPaymentDisclaimer: "Se va a realizar un primer pago de {{amount}}. El día {{nextPaymentDate}} se cobrará automáticamente el resto del importe ({{nextPaymentAmount}}).",
    },
    bookOk: {
        creditCard: "Pago con tarjeta",
        yourBooking: "Su reserva",
        bookingConfirmed: "Su reserva ha sido confirmada",
        bookingConfirmedAndPaid: "Su reserva ha sido confirmada y pagada",
        bookingScheduledPayment: "Se ha programado un pago de {{nextPaymentAmount}} para el día {{nextPaymentDate}}. Una vez realizado, su reserva quedará confirmada y recibirá un correo de confirmación.",
        bookingCanceled: "Su reserva ha sido cancelada",
        boolingCanceledAndRefunded: "Su reserva ha sido cancelada y reembolsada",
        roomsWithOverbookingDisclaimer: "Muchas gracias por su reserva. Nos pondremos en contacto con usted lo antes posible, ya que esta reserva está pendiente de confirmación para los próximos días.",
        statusBookingNotOverbooking: 'Estado de su reserva: Habitación reservada y pendiente de pago',
        statusBookingOverbooking: 'Estado de su reserva: Habitación bloqueda y pendiente de confirmación',
        rememberPayHotel: "Recuerde que al llegar al hotel tendrá que pagar ",
        needToPay: "Hemos recibido su reserva. Este hotel requiere el pago por adelantado.",
        rememberPay: "Hemos recibido su reserva. Este hotel requiere el pago anticipado de la reserva. Puede realizar el pago ahora <PayCometIcon/> o hacerlo un mes antes de que comience el evento. En ese caso, se le enviará un enlace de pago por correo electrónico.",
        selectPaymentMethod: "Selecciona su método de pago preferido:",
        confirmationNumber: "Número de confirmación",
        nameAndSurnames: "Nombre y apellidos",
        email: "Email de contacto",
        telephone: "Teléfono de contacto",
        hotelDetails: "Detalles del hotel",
        hotelDetailsSubtitle: "Información del alojamiento reservado",
        event: "Evento",
        city: "Ciudad",
        hotel: "Hotel",
        address: "Dirección",
        payMethod: "Método de pago",
        payOnHotel: "Pago directo en el hotel",
        roomDetails: "Detalle de habitaciones",
        roomDetailsSubtitle: "Habitaciones incluidas en tu reserva",
        roomType: "Tipo de habitación",
        occupancy: "Nº de personas",
        arrivalHour: "Hora de llegada",
        guest: "Huésped",
        total: "Total",
        transferServiceDescription: "Si lo deseas, puedes reservar un traslado con nosotros para completar tu experiencia.",
        bookTransfer: "Reservar Traslado",
        totalPending: "Total pendiente",
        paymentsMade: "Pagos realizados",
        taxesAndFees: "Impuestos y tasas",
        discount: "Descuento",
        totalBasket: "Total reserva",
        totalPaid: 'Total pagado',
        taxes: "Impuestos",
        totalRooms: "Total alojamiento",
        totalRoomsSubtitle: "Importe por la estancia y habitaciones seleccionadas",
        summaryTitle: "Resumen de la reserva",
        summarySubtitle: "A continuación puedes ver el desglose de los importes de tu reserva.",
        totalPendingSubtitle: "Importe restante por pagar",
        paymentsSubtitle: 'Importe que ya has pagado',
        taxesSubtitle: 'Impuestos aplicables a tu reserva',
        payment: 'Pago',
        payments: "Pagos",
        refund: "Reembolso",
        refunds: "Reembolsos",
        refundsSubtitle: "Importe que se ha reembolsado",
        paymentDateUnknown: "Unknown date",
        paymentMethod: "Method",
        paymentDate: "Date",
        noPayments: "No payments",
        payWithSelectedCard: "Pagar con tarjeta seleccionada",
        processing: "Procesando...",
        paymentError: "Error al procesar el pago. Inténtalo de nuevo.",
        payByCard: "Tarjeta",
        payAmount: "Pagar {{amount}}",
        payWithLuxon: "Pagar {{amount}} con Luxon",
        luxonDescription: "Paga de forma rápida y segura con Luxon, el método de pago para el ocio y los eventos.",
        redirecting: "Redirigiendo...",
        payNow: "Pagar ahora",
        payLater: "Pagar más tarde",
        schedulePayment: "Programar pago",
        schedulePaymentAmount: "Programar pago de {{amount}}",
        scheduledPaymentInfoTotalHead: "Hoy solo se realizará una verificación de 0,01 que se devolverá automáticamente.",
        scheduledPaymentInfoTotal: "El importe total de la reserva se cargará automáticamente en la tarjeta registrada en la fecha indicada.",
        scheduledPaymentInfoPartialHead: "El importe que se cargará el día de hoy es un pago inicial para garantizar la reserva.",
        scheduledPaymentInfoPartial: "El importe restante de la reserva se cargará automáticamente en la tarjeta registrada en la fecha indicada.",
        paymentBreakdown: "Desglose de pago",
        initialPayment: "Pago inicial hoy",
        preauthorization: "Comprobación de tarjeta",
        remainingPayment: "Pago restante el {{date}}",
        totalAmount: "Importe total",
     },
    transfers: {
        fields: {
            transferDetails: "Detalles de Traslado",
            personalDetails: "Detalles Personales",
            passengerName: "Nombre",
            passengerLastName: "Apellidos",
            passengerContactEmail: "Correo Electrónico",
            passengerPhoneNumber: "Número de Teléfono",
            dialCode: "Código País",
            oneWayTransfer: "Traslado de Llegada",
            returnTransfer: "Traslado de Salida",
            arrivalTransport: "Transporte de Llegada",
            arrivalLocationFrom: "Ubicación de Llegada",
            arrivalLocationFromAirplane: "Aeropuerto de Llegada",
            arrivalLocationFromTrain: "Estación de Llegada",
            arrivalLocationFromBus: "Estación de Llegada",
            arrivalLocationTo: "Donde te Dejamos",
            departureTransport: "Transporte de Salida",
            departureLocationFrom: "Lugar de Recogida",
            departureLocationToAirplane: "Aeropuerto de Salida",
            departureLocationToTrain: "Estación de Salida",
            departureLocationToBus: "Estación de Salida",
            departureLocationTo: "Punto de Destino",
            arrivalLocationFromDetails: "Detalles de la dirección de llegada",
            arrivalLocationToDetails: "Detalles de donde te dejamos",
            departureLocationFromDetails: "Detalles del lugar de recogida",
            departureLocationToDetails: "Detalles del punto de destino",
            arrivalTransportDate: "Fecha de Llegada",
            flightArrivalDate: "Fecha de Llegada del Vuelo",
            trainArrivalDate: "Fecha de Llegada del Tren",
            busArrivalDate: "Fecha de Llegada del Autobús",
            departureTransportDate: "Fecha de Salida",
            flightDepartureDate: "Fecha de Salida del Vuelo",
            trainDepartureDate: "Fecha de Salida del Tren",
            busDepartureDate: "Fecha de Salida del Autobús",
            arrivalTransportTime: "Hora de Llegada",
            flightArrivalTime: "Hora de Llegada del Vuelo",
            trainArrivalTime: "Hora de Llegada del Tren",
            busArrivalTime: "Hora de Llegada del Autobús",
            departureTransportTime: "Hora de Salida",
            flightDepartureTime: "Hora de Salida del Vuelo",
            trainDepartureTime: "Hora de Salida del Tren",
            busDepartureTime: "Hora de Salida del Autobús",
            arrivalNumberOfPassengers: "Número de Pasajeros (Llegada)",
            departureNumberOfPassengers: "Número de Pasajeros (Salida)",
            pickUpTime: "Hora de Recogida",
            pickUpTimeHelper: "Para garantizar una experiencia de salida sin problemas, recomendamos seleccionar una hora de recogida que permita al menos 2 horas antes de su vuelo, más el tiempo de viaje al aeropuerto",
            airline: "Aerolínea",
            flightNumber: "Número de Vuelo",
            trainCompany: "Compañía de Tren",
            trainNumber: "Número de Tren",
            busCompany: "Compañía de Autobús",
            busNumber: "Número de Autobús",
            transportReference: "Referencia del Transporte",
            transportReferenceNumber: "Número de Referencia del Transporte",
            comments: "Comentarios",
            sedan: "Sedan",
            van: "Van",
            businessSedan: "Business Sedan",
            businessVan: "Business Van",
            maxPassengers: "Máx. pasajeros",
            direction: "Dirección",
            status: "Estado",
            price: "Precio",
            confirmationNumber: "Número de Confirmación",
            vehicle: "Vehículo",
            luggageCapacity: "Capacidad de Equipaje",
            termsAndConditions: 'Términos y Condiciones del Traslado',
            termsAndConditionsInfo: {
                cancellation: 'Política de cancelación: Los traslados al aeropuerto no se pueden cancelar gratuitamente dentro de las 24 horas previas a la hora de recogida programada. Las cancelaciones realizadas con menos de 24 horas de antelación no son reembolsables.',
                missedFlights: 'Vuelos Perdidos: Si pierde su vuelo y requiere un nuevo traslado, esto se tratará como una nueva reserva y se cobrará en consecuencia.',
                flightDelays: 'Retrasos de Vuelo: Si su vuelo se retrasa, no se preocupe, su conductor monitoreará su vuelo y ajustará la hora de recogida según la hora real de llegada del vuelo.',
            },
        },
        message: {
            typeOfTransfer: "Tipo de Traslado",
            formTitle: "Servicio de Traslado de Aeropuerto",
            transferDetailsSent: "Los detalles del traslado han sido enviados a {{email}}",
            succesCreatingRequestTransfer: "Tu solicitud de traslado ha sido enviada exitosamente. ",
            newTransferRequest: "Solicitar nuevo traslado",
            confirmationShortly: "Verificaremos todos los detalles y te enviaremos un correo de confirmación en breve.",
            paymentEmailNotice: "Pronto recibirás un correo electrónico con un enlace de pago. Una vez completado el pago, confirmaremos tu traslado.",
            anyChanges: "Para cualquier cambio, por favor contacta: {{email}}.",
            mustReadTerm: "Debes aceptar los términos y condiciones",
            noVehiclesAvailable: "No hay vehículos disponibles",
            termsLinkMessage: "Acepto los",
            termsTitle: "Términos y Condiciones",
            footerDescription2: "Recibirás una confirmación de tu solicitud en {{customerEmail}}",
            comments: "Comentarios",
            selectTransportFirst: "Selecciona un transporte primero",
            selectArrivalLocationFromFirst: "Selecciona una ubicación de llegada primero",
            selectDepartureLocationFromFirst: "Selecciona una ubicación de recogida primero",
            enterAddressDetails: "Por favor ingresa la dirección detallada (calle, edificio, número de apartamento, etc.)",
            selectVehicleArrival: "Selecciona tu vehículo de llegada",
            selectVehicleDeparture: "Selecciona tu vehículo de salida",
            customRoute: "Verificaremos el costo de esta ruta personalizada para ti y te enviaremos el precio por correo electrónico dentro de 24 horas",
            noTransfers: "No tienes traslados aún.",
            toConfirm: "Por confirmar",
        },
    },
    transferSearch: {
        fields: {
            city: "Ciudad",
        },
        message: {
            searchByDirection: "Buscar por dirección",
            searchByTransferStatus: "Buscar por estado del traslado",
            searchByConfirmationNumber: "Buscar por número de confirmación",
            searchByCity: "Buscar por ciudad",
            searchByEvent: "Buscar por evento",
            searchByHotel: "Buscar por hotel",
            searchByYear: "Buscar por año",
        }
    },
    transferOk: {
        fields: {
            nameAndSurnames: "Nombre y Apellidos",
            event: "Evento",
            totalTransfer: "Total Traslado",
            totalTransferSubtitle: "Importe por el traslado seleccionado",
            totalToPay: "Total a pagar",
            totalPaid: "Total pagado",
            numberOfPassengers: "Nº de pasajeros",
            locationFrom: "Desde",
            locationTo: "Hasta",
            person: "persona",
            persons: "personas",
            arrivalInstructions: "Instrucciones de Llegada",
            departureInstructions: "Instrucciones de Salida"
        },
        message: {
            yourTransfer: "Su reserva de traslado",
            transferConfirmed: "Su traslado ha sido confirmado.",
            transferConfirmedAndPaid: "Su traslado ha sido confirmado y pagado.",
            transferPaymentRequested: "Se ha solicitado el pago de su traslado. Una vez recibido el pago, su traslado quedará confirmado y recibirá un correo de confirmación.",
            transferPending: "Su traslado está pendiente de confirmación.",
            transferCanceled: "Su traslado ha sido cancelado.",
            transferCanceledAndRefunded: "Su traslado ha sido cancelado y reembolsado.",
            transferDetails: "Detalles del Traslado",
            personalDetails: "Detalles personales",
            eventDetails: "Detalles del evento",
            bookAnotherTransfer: "Reservar otro traslado",
            sharedWithPassenger: "Compartido con",
            flightDetails: "Detalles del vuelo",
            trainDetails: "Detalles del tren",
            busDetails: "Detalles del autobús",
            transportDetails: "Detalles del transporte",
            personalDetailsSubtitle: "Información personal de la reserva",
            eventDetailsSubtitle: "Información del evento de la reserva",
            transportDetailsSubtitle: "Información del transporte",
            transferDetailsSubtitle: "Información del traslado",
        }
    },
    terms: {
        labels: {
            readCompleteDocument: "Lee el documento completo.",
            revised: "revisado",
            scrollToTheEnd: "Desplázate hasta el final",
            documentRevised: "Documento Revisado",
            mustReadAllDocument: "Debes revisar el documento completo antes de aceptarlo.",
        }
    },
    paymentCard: {
        saveCard: "Guardar tarjeta",
        cardSavedSuccess: "Tu tarjeta ha sido guardada correctamente",
        noSavedCards: "No tienes tarjetas guardadas",
        selectCard: "Seleccionar tarjeta de pago",
        addCard: "Añadir nueva tarjeta",
        cancelAddCard: "Cancelar",
        saveAndSelect: "Guardar y seleccionar",
        mustSelectCard: "Debes seleccionar una tarjeta para continuar",
        changeCard: "Cambiar tarjeta",
        cardAdded: "Tarjeta añadida",
        securePayment: "Pago seguro con cifrado SSL",
        primary: 'Principal',
        isPrimary: "Tarjeta principal",
        setPrimary: 'Establecer como tarjeta principal',
    },
    packages: {
        fields: {
            selectARoom: 'Selecciona una habitación',
            selectRoom: 'Seleccionar Habitación',
            addMoreRooms: 'Añadir más habitaciones',
            completePersonalDetails: 'Completar datos personales',
            completeTransferDetails: 'Completar detalles de traslado',
            personalDetails: 'Detalles Personales',
            personalDetailsDescription: 'Completa tus datos personales para finalizar tu reserva',
            addAnotherTransfer: 'Añadir otro traslado',
        },
        message: {
            winnerPackageNoticeBanner: "Enhorabuena por ganar un paquete para el {{cityEvent}} del {{startDate}} al {{endDate}}. ",
            packageIncludedOneTransfer: "Enhorabuena, tu paquete incluye un traslado gratuito a la llegada o a la salida. Por favor, completa los detalles para continuar.",
            packageIncludedNoTransfer: "Enhorabuena, tu paquete no incluye traslados. Por favor, completa tus datos personales para finalizar tu reserva.",
            confirmAccommodationDates: 'Confirmar fechas alojamiento',
            canCheckInEarlierOrCheckOutLater: 'Si lo necesitas, puedes llegar antes o marchar más tarde de tu alojamiento.',
            canBookAnotherTransfer: 'Si lo necesitas, puedes reservar otro traslado con nosotros, pero este si deberá abonarlo.',
            optionalTransferAllOrNothing: 'Has empezado a rellenar el traslado adicional. Completa todos los campos o déjalo vacío para continuar.',
        },
        validation: {
            selectRoomDescription: "Selecciona una habitación para continuar",
            addMoreIfYouNeed: "Si deseas añadir más habitaciones adicionales a la que ya has ganado, selecciónalas. Si no, continúa.",
            completePersonalDetails: "Completar datos personales para continuar",
            roomRequired: "Debes seleccionar una habitación",
            personalDetailsRequired: "Debes completar tus datos personales",
            datesRequired: "Debes seleccionar las fechas de alojamiento",
            startDateTooEarly: "La fecha de inicio no puede ser anterior a {{minStartDate}}",
            endDateTooLate: "La fecha de fin no puede ser posterior a {{maxEndDate}}",
            invalidDateRange: "La fecha de inicio debe ser anterior a la fecha de fin",
            startDateOutOfRange: "La fecha de inicio debe estar entre {{minDate}} y {{maxDate}}",
            endDateOutOfRange: "La fecha de fin debe estar entre {{minDate}} y {{maxDate}}",
            startDateBeforeEvent: "La fecha de inicio no puede ser anterior a la fecha de inicio del evento ({{eventStartDate}})",
            endDateAfterEvent: "La fecha de fin no puede ser posterior a la fecha de fin del evento ({{eventEndDate}})",
        }
    },
};

export default translations;
